import { render, staticRenderFns } from "./CellNumber.vue?vue&type=template&id=e28ea7ba&scoped=true&lang=pug&"
import script from "./CellNumber.vue?vue&type=script&lang=js&"
export * from "./CellNumber.vue?vue&type=script&lang=js&"
import style0 from "./CellNumber.vue?vue&type=style&index=0&id=e28ea7ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28ea7ba",
  null
  
)

export default component.exports